import { ExtractedPackingListTableItem } from "api/models/documentProcessor";
import { ReactComponent as TrashIcon } from "assets/images/iconsV2/trash-01.svg";
import Button from "components/v2/Button/Button";
import PackingListMeasurementsForm from "./PackingListMeasurementsForm";
import PackingListBasicChecks from "./PackingListBasicChecks";
import PackingListSpecialHandlingForm from "./PackingListSpecialHandlingForm";
import PackingListCustomsInfoForm from "./PackingListCustomsInfoForm";
import "./PackingListItemForm.scss";

interface PackingListItemFormProps {
  index: number;
  selectedJob?: ExtractedPackingListTableItem;
  handleRemovePackingListItem: (index: number) => void;
}

export default function PackingListItemForm({ index, selectedJob, handleRemovePackingListItem }: PackingListItemFormProps) {
  return (
    <div className="d-flex pb-2xl">
      <div className="pr-5xl pb-sm d-flex flex-column align-items-center">
        <div className="text-brand-secondary font-semibold text-lg">{index + 1}</div>
        <div className="horizontal-divider" />
      </div>

      <div className="d-flex flex-column gap-xl">
        <div className="d-flex">
          <PackingListMeasurementsForm
            index={index}
            paymentLocationReferenceNumber={selectedJob?.payment_location_reference_number}
          />
          {index !== 0 && (
            <div>
              <Button
                iconLeft={<TrashIcon />}
                variant="link-error"
                className="pb-lg"
                onClick={() => handleRemovePackingListItem(index)}
              />
            </div>
          )}
        </div>

        <div className="packing-list-item-form__checkbox-grid">
          <PackingListBasicChecks index={index} />
          <PackingListSpecialHandlingForm index={index} />
        </div>

        <div>
          <PackingListCustomsInfoForm index={index} />
        </div>
      </div>
    </div>
  );
}

PackingListItemForm.defaultProps = {
  selectedJob: undefined,
};
